import { createComponent } from '@bigyouth/base'

import './style/styles-nextsail.scss'
import * as features from './features/exports/nextsail'

Object.values(features).forEach(createComponent)
